import React from "react";
import "./styles.css"
import { MobileNoEntriesTableRow } from "components/shared/views/TableView/components/MobileNoEntriesTableRow";
import MobileACHTransfersToTableRow from "../MobileACHTransfersToTableRow";

/**
 * @function MobileACHTransfersToTable
 * @return {React.Component}
 * @exported true
 * @description - This is the "One Time ACH To" mobile main table view for the OneTimeACHPaymentPage.
 */
export default function MobileACHTransfersToTable(props) {
    const achToParticipants = props.achToParticipants ?? {};
    const onACHToParticipantChange = props.onACHToParticipantChange ?? (() => {});
    const onACHToParticipantDelete = props.onACHToParticipantDelete ?? (() => {});
    const showHoldPrenoteDistributionColumns = props.showHoldPrenoteDistributionColumns ?? false;

    const rows = achToParticipants.participants.reduce((acc, item) => {
        acc.push(
            <MobileACHTransfersToTableRow key={ item.id } achToParticipant={ item } onACHToParticipantChange={ onACHToParticipantChange } 
            onACHToParticipantDelete={ onACHToParticipantDelete } showHoldPrenoteDistributionColumns={ showHoldPrenoteDistributionColumns } />
        );
        return acc;
    }, []);
    const hasRows = rows.length > 0;

    return (
        <div className="mobile-one-time-ach-to-table show-on-mobile">
            { hasRows && rows }
            { !hasRows && <MobileNoEntriesTableRow /> }
        </div>
    )
}
